import React, { useEffect } from 'react';
import InputField from '@wix/da-ds/pkg/formControls/lego/InputField';
import ListItemRadioButton from '@wix/da-ds/pkg/List/ListItem/dsPresets/ListItemRadioButton';
import TextAreaInputField from '@wix/da-ds/pkg/formControls/lego/TextAreaInputField';
import InputLabel from '@wix/da-ds/pkg/formControls/lego/InputLabel';
import classnames from 'classnames';
import { DeprecatedQuestions } from '../redux/constants';
import { URLS } from '@wix/da-url';
// eslint-disable-next-line @wix/da/scss-same-filename-as-module
import s from '../ReportPage.scss';
const GenericForm = ({ onMount, formData, formRegister, formErrors, formSetValue, formGetValues })=>{
    useEffect(()=>{
        formData && onMount(formData.formId);
    }, [
        onMount,
        formData
    ]);
    // parses FAQ urls with centralized policy urls in question labels
    // server label fiels is limited to 255 characters so HTML links isnt feasible
    // also this avoids dealing with dangerouslySetInnerHTML
    const parseFaqUrls = (label)=>{
        return label.split(/FAQ\s/).map((part, index)=>index % 2 === 1 ? /*#__PURE__*/ React.createElement("span", {
                key: index
            }, /*#__PURE__*/ React.createElement("a", {
                href: URLS.MATURE_POLICY,
                target: "_blank",
                rel: "noreferrer"
            }, "FAQ"), ' ', part) : part);
    };
    const renderField = (fieldName, question)=>{
        // bail on deprecated questions
        if (DeprecatedQuestions.includes(question.id)) {
            return;
        }
        const label = parseFaqUrls(question.label);
        formRegister(fieldName, {
            required: !question.optional
        });
        switch(question.type){
            case 'textarea':
                return /*#__PURE__*/ React.createElement(InputLabel, null, /*#__PURE__*/ React.createElement("p", null, label), /*#__PURE__*/ React.createElement(TextAreaInputField, {
                    name: fieldName,
                    className: s['formTextarea'],
                    ref: formRegister
                }));
            case 'textfield':
                return /*#__PURE__*/ React.createElement(InputLabel, null, /*#__PURE__*/ React.createElement("p", null, label), /*#__PURE__*/ React.createElement(InputField, {
                    type: "text",
                    name: fieldName,
                    className: s['formTextbox'],
                    ref: formRegister
                }));
            case 'checkgroup':
                return [
                    /*#__PURE__*/ React.createElement("p", {
                        key: 'label'
                    }, label),
                    /*#__PURE__*/ React.createElement("p", {
                        key: 'checkgroup'
                    }, question.items.map((item)=>/*#__PURE__*/ React.createElement(InputLabel, {
                            className: s['formInputControl'],
                            key: item.label
                        }, /*#__PURE__*/ React.createElement("input", {
                            type: 'checkbox',
                            name: fieldName,
                            value: item.label,
                            ref: formRegister
                        }), ' ', item.label, item.help && /*#__PURE__*/ React.createElement("em", null, item.help))))
                ];
            case 'radiogroup':
                return [
                    /*#__PURE__*/ React.createElement("p", {
                        key: 'label'
                    }, label),
                    /*#__PURE__*/ React.createElement("p", {
                        key: 'checkgroup'
                    }, question.items.map((item)=>/*#__PURE__*/ React.createElement(ListItemRadioButton, {
                            name: fieldName,
                            key: item.label,
                            value: item.label,
                            label: item.label,
                            subLabel: item.help,
                            onChange: (e)=>formSetValue(fieldName, item.label)
                        })))
                ];
            case 'url':
                return [
                    /*#__PURE__*/ React.createElement("p", {
                        key: "label"
                    }, label),
                    /*#__PURE__*/ React.createElement("p", {
                        key: "url"
                    }, question.items.map((item)=>/*#__PURE__*/ React.createElement("a", {
                            className: s['formLink'],
                            href: item.help,
                            key: item.label
                        }, item.label)))
                ];
            default:
                return /*#__PURE__*/ React.createElement("p", null, label);
        }
    };
    return /*#__PURE__*/ React.createElement("ul", {
        className: s['section']
    }, formData && formData.questions.map((question)=>{
        const fieldName = `${question.type}_${question.id}`;
        const hasError = Boolean(formErrors[fieldName]);
        return /*#__PURE__*/ React.createElement("li", {
            key: question.id,
            className: classnames(!question.optional && s['formRequired'], hasError && s['formError'])
        }, renderField(fieldName, question));
    }));
};
GenericForm.displayName = 'GenericForm';
export default GenericForm;

//# sourceMappingURL=GenericForm.js.map